<div class="content">
  <div class="close">
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div *ngIf="tableResult">
    <div class="example-container mat-elevation-z8">
      <div class="table-wrapper">
        <div class="table-scroll">
          <mat-table
            *ngIf="!noDAta"
            [dataSource]="dataSource"
            class="mat-elevation-z8"
          >
            <!-- Columna de selección (sticky) -->
            <ng-container matColumnDef="select" sticky>
              <mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="toggleAll()"></mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                <mat-checkbox
                  (change)="toggleSelection(row)"
                  [checked]="selection.isSelected(row)"
                ></mat-checkbox>
              </mat-cell>
            </ng-container>

            <!-- Columnas dinámicas -->
            <ng-container
              *ngFor="let keysEntitie of keysEntities"
              [matColumnDef]="keysEntitie"
            >
              <mat-header-cell *matHeaderCellDef class="header-cell">
                {{ keysEntitie }}
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="cell">
                {{ row[keysEntitie] }}
              </mat-cell>
            </ng-container>

            <!-- Encabezado y filas -->
            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
          <div *ngIf="noDAta" class="nodata">
            <h1>No se encontraron datos</h1>
          </div>
        </div>
      </div>
    </div>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
    ></mat-paginator>

    <button mat-button (click)="createSelectedEntities()">
      Crear entidades seleccionadas
    </button>
  </div>
  <api-sl-form-rq
    [valueInput]="data.value"
    [categoryInput]="data.category"
    [aviableApis]="aviableApis"
    (resultEntities)="setTableResult($event)"
    *ngIf="!tableResult"
  ></api-sl-form-rq>
</div>
